import Resource from '@/api/resources/Resource'

class SampleTypeLaboratoryService extends Resource {
    async findSampleTypeLaboratoryBySampleTypeId(laboratoryId, sampleTypeId) {
        return this.axios.get(`/common/laboratories/${laboratoryId}/sampleTypes/${sampleTypeId}/sampleTypeLaboratory`)
            .then(response => response.data)
    }
}

export default new SampleTypeLaboratoryService()
